import { render, staticRenderFns } from "./BookSysVip.vue?vue&type=template&id=9725505e&scoped=true"
import script from "./BookSysVip.vue?vue&type=script&lang=js"
export * from "./BookSysVip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9725505e",
  null
  
)

export default component.exports